import { List, useRecordContext } from "react-admin";

import { LocationRecordWithUsers } from "../types/location";
import { PractitionerDataGrid } from "./PractitionerDataGrid";

export const LocationPractitionersList = () => {
  const record = useRecordContext<LocationRecordWithUsers>();

  if (!record) {
    return null;
  }

  return (
    <List
      resource="Practitioner"
      filter={{ locationId: record.id }}
      perPage={50}
      actions={false}
      sx={{
        "& .RaList-main": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <PractitionerDataGrid showLocationColumn={false} />
    </List>
  );
};
